// src/App.js

import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Toaster } from 'react-hot-toast';
import ErrorBoundary from './components/ErrorBoundary';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeContextProvider, useThemeMode } from './contexts/ThemeContext';

// ページコンポーネント
import Landing from './routes/Landing/Landing';
import Home from './routes/Home/Home';
import Login from './routes/Login/Login';
import Admin from './routes/Admin/Admin';
import NotFound from './components/NotFound';
import RecruitPlanAssistant from './routes/RecruitPlanAssistant/RecruitPlanAssistant';
import MediaSelection from './routes/MediaSelection/MediaSelection';
import JobPostCreation from './routes/JobPostCreation/JobPostCreation';
import InterviewSupport from './routes/InterviewSupport/InterviewSupport';
import Settings from './routes/Setting/Settings';
import Terms from './routes/Terms/Terms';
import Privacy from './routes/Privacy/Privacy';

// ルート保護コンポーネント
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';

function AppContent() {
  const { theme } = useThemeMode();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* 公開ページ（認証不要） */}
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />

            {/* 認証必須ページ（PrivateRouteで保護） */}
            <Route path="/landing" element={<PrivateRoute><Landing /></PrivateRoute>} />
            <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute>} />
            <Route path="/plans" element={<PrivateRoute><RecruitPlanAssistant /></PrivateRoute>} />
            <Route path="/media" element={<PrivateRoute><MediaSelection /></PrivateRoute>} />
            <Route path="/job-posts" element={<PrivateRoute><JobPostCreation /></PrivateRoute>} />
            <Route path="/interview-support" element={<PrivateRoute><InterviewSupport /></PrivateRoute>} />
            <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />

            {/* 管理者専用ページ（AdminRouteで保護） */}
            <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
            <Route path="/Admin" element={<AdminRoute><Admin /></AdminRoute>} />

            {/* 未定義のルート */}
            <Route path="*" element={<NotFound />} />
          </Routes>

          {/* Toast通知用コンポーネント */}
          <Toaster />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeContextProvider>
        <AppContent />
      </ThemeContextProvider>
    </ErrorBoundary>
  );
}

export default App;
